import { Divider, Row } from "antd";

import { BackToButton } from "components/Shared/BackToButton";
import { PageTitle } from "components/Shared/PageTitle";
import { ActAsTypes } from "enums/actAsTypes.ts";
import { useFetchOrganizations } from "hooks/useUsersApi";
import { useState } from "react";
import { useIntl } from "react-intl";
import { getActAsTypes } from "utils/getActAsTypes.ts";
import { BaseEntityCard } from "./components/BaseEntityCard";
import { SelectTable } from "./SelectTable";

export const SelectOrganizationPage = () => {
  const { formatMessage } = useIntl();
  const [searchText, setSearchText] = useState("");
  const { isLoading, data: organizationsResponse } = useFetchOrganizations();
  const organizations = organizationsResponse?.data || [];
  const filteredOrganizations = organizations.filter(
    (x: any) =>
      x?.nameLocal?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1 ||
      x?.organizationId?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1
  );

  const getOrganizationLink = (org): string => {
    const actAsTypes = getActAsTypes(org?.availableUserRoles);
    if (actAsTypes.includes(ActAsTypes.Admin) && actAsTypes.includes(ActAsTypes.TeamManager)) {
      return `${org?.sport}/${org?.organizationId}/role`;
    }
    if (actAsTypes.includes(ActAsTypes.Admin)) {
      return `${org?.sport}/${org?.organizationId}/admin`;
    }
    if (actAsTypes.includes(ActAsTypes.TeamManager)) {
      return `${org?.sport}/${org?.organizationId}/entities`;
    }
    return "";
  };

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <PageTitle isLoading={false} title={formatMessage({ id: "selectOrganizationPage.title" })} />
        <BackToButton to="/" btnText={formatMessage({ id: "back.to.customers" })} />
      </Row>
      <Divider />
      <Row justify="center">
        <SelectTable
          isLoading={isLoading}
          items={filteredOrganizations}
          validations={[
            {
              message: formatMessage({ id: "selectOrganizationPage.noAccess" }),
              check: () => organizations.length === 0,
            },
            {
              message: formatMessage({
                id: "selectOrganizationPage.noUserRoles",
              }),
              check: () => organizations.every((x: any) => x?.availableUserRoles?.length === 0),
            },
          ]}
          onSearch={setSearchText}
          render={(x: any) => (
            <BaseEntityCard
              key={x?.organizationId}
              to={getOrganizationLink(x)}
              name={x?.nameLocal}
              desc={`Org ID: ${x?.organizationId} | ${x?.sport}`}
            />
          )}
        />
      </Row>
    </>
  );
};
